import React from 'react';
import { Link } from 'react-router-dom';

/** Fixed header on content pages: Back link on the left, title in the middle. */
export default function TopBar({ backTo, title }) {
  return (
    <div className="top-bar">
      <Link to={backTo} className="back-button">← Back</Link>
      <div className="top-bar-title">{title}</div>
      <div className="top-bar-end" />
    </div>
  );
}
